





















































































































import { Component, Vue } from "vue-property-decorator";
import {Miner, Contract, CompanyCreate} from "@/interfaces";

import { dispatchGetMiners,dispatchCreateCompany} from "@/store/main/actions";
import { readHasAdminAccess, readMiners } from "@/store/main/getters";

@Component
export default class CreateCompany extends Vue {


  public loading = false;

  public companyName = "";
  public miners: Miner[] = [];
  public contracts: Contract[] = [];
  public selectedMiners: number[] = [];

  public dialog = false;
  public dialogMessages: string[] = [];

  public async mounted() {


    await Promise.allSettled([
      dispatchGetMiners(this.$store),
    ]);
    this.miners = readMiners(this.$store)

  }

  get isAdmin() {
    return readHasAdminAccess(this.$store);
  }

  public addContract(){

    this.contracts.push({
      name: "",
      share: 0,
      is_director: false,
      get_notification : false,
      mobile: ""
    });
  }

  public removeContract(index){
    this.contracts.splice(index, 1);
  }

  public async submit() {

    let isValid = true;
    let companyNameError = "";
    let minerError = "";
    let mobileError = "";
    let shareError = "";
    let contractError = "";
    // let directorError = "";

    if (this.companyName.length == 0){
      companyNameError = "لطفا نام کمپانی را وارد کنید";
      isValid = false;
    }

    if (this.selectedMiners.length == 0){
      minerError = "لطفا حداقل یک ماینر انتخاب کنید";
      isValid = false;
    }

    if (this.contracts.length <= 1){
      contractError = "لطفا حداقل دو قرارداد وارد کنید";
      isValid = false;
    }


    let shareCount = 0;
    let directorCount = 0;

    this.contracts.map(item=>{

      if (item.mobile?.length != 11){
        mobileError = "لطفا شماره موبایل ها را به درستی وارد کنید";
        isValid = false;
      }

      if (item.share == 0){
        shareError = "مقدار سهم باید بیشتر از صفر باشد";
        isValid = false;
      }

      shareCount += +(item.share);

      if (item.is_director)
        directorCount ++;

    });

    if (shareCount != 100){
      shareError = "مجموع سهم ها باید صد درصد باشد";
      isValid = false;
    }

    if (directorCount == 0){
      shareError = "حداقل یک مدیر انتخاب کنید";
      isValid = false;
    }
    if (directorCount > 1){
      shareError = "حداکثر یک مدیر انتخاب کنید";
      isValid = false;
    }

    if (isValid){

      const company: CompanyCreate = {
        name: this.companyName,
        miner_ids: this.selectedMiners,
        contracts: this.contracts
      }

      const own = !this.isAdmin // if user is admin, set own to false

      this.loading = true;
      const result = await dispatchCreateCompany(this.$store,{data: company,own: own});

      if (result === true){
        this.loading = false;
        await this.$router.push("/main/company/all");
      }else{
        this.dialogMessages = [];
        this.dialogMessages.push(""+result);
        this.dialog = true;
      }




    }else{
      this.dialogMessages = [];
      this.dialogMessages.push(companyNameError,minerError , contractError , mobileError , shareError);
      this.dialog = true;
    }


  }

}
